import { PackageBuilderSummaryProduct } from './package-builder-summary-product.model';

export class PackageBuilderSummary {
  wheel: PackageBuilderSummaryProduct;
  tire: PackageBuilderSummaryProduct;
  hardwares: PackageBuilderSummaryProduct[] = [];
  labours: PackageBuilderSummaryProduct[] = [];
}
